import classnames from 'classnames';
import type { FC } from 'react';
import { RadioInput } from '@/core/tamagoshi/CheckerInput/RadioInput';
import { Text } from '@/core/tamagoshi/Text/Text';
import { translate } from '@/domains/core/localization/translate';
import type { Distribution } from '@/domains/productDiscovery/ArticleReviews/ArticleReviews.model';
import styles from './ratingbar.module.scss';
interface Props {
  distribution: Distribution;
  starsFilter?: number | null;
  toggleStarsFilter?: (rating: number) => void;
  clearStarsFilter?: () => void;
  isModal?: boolean;
}
const {
  clearFilters
} = translate({
  "clearFilters": "Clear filter"
});
export const sortDescendingDistribution = (distribution: Distribution) => Object.entries(distribution).sort((a, b) => Number(b[0]) - Number(a[0]));
export const RatingBars: FC<Props> = ({
  distribution,
  starsFilter = [],
  toggleStarsFilter = () => null,
  clearStarsFilter = () => null,
  isModal = false
}) => {
  const ratingsTotal = Object.values(distribution).reduce((acc, curr) => acc + curr, 0);
  const containerClassName = classnames(styles.ratingBarContainer, {
    [styles.modalContainer]: isModal
  });
  const svg = isModal ? <svg width="18" height="17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M8.99983 14.27l4.14997 2.51c.76.46 1.69-.22 1.49-1.08l-1.1-4.72 3.67-3.17999c.67-.58.31-1.68-.57-1.75l-4.83-.41-1.88997-4.46c-.34-.81-1.5-.81-1.84 0l-1.89 4.45-4.83.41c-.880002.07-1.240002 1.17-.570002 1.75L4.45983 10.97l-1.1 4.72c-.2.86.73 1.54 1.49 1.08l4.15-2.5z" fill="#FFB950" />
    </svg> : <svg width="12" height="12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M6 9.51332l2.76667 1.67338c.50667.3066 1.12667-.1467.99333-.72l-.73333-3.14671 2.44663-2.12c.4467-.38667.2067-1.12-.38-1.16667l-3.21996-.27333-1.26-2.973337c-.22667-.54-1-.54-1.22667 0l-1.26 2.966667-3.220001.27333c-.586666.04667-.8266664.78-.38 1.16667l2.446671 2.12L2.24 10.46c-.13333.5733.48667 1.0267.99334.72L6 9.51332z" fill="#FFB950" />
    </svg>;
  return <div className={containerClassName} data-testid="rating-bar-modal">
      {sortDescendingDistribution(distribution).map(([key, quantity]) => {
      const percentage = ratingsTotal !== 0 ? Number((quantity / ratingsTotal * 100).toFixed(0)) : 0;
      return <div key={key} className={styles.segment}>
            <div className={styles.segmentLabel}>
              {svg}
              <span className={styles.segmentText}>{`${key}`}</span>
            </div>
            <div className={styles.percentageBar}>
              <div style={{
            width: `${percentage}%`
          }} className={styles.percentageValue} />
            </div>
            {isModal && <RadioInput aria-label={key} id={`rating-checkbox-${key}`} name={key} isChecked={starsFilter === Number(key)} isDisabled={quantity === 0} onChange={() => toggleStarsFilter(Number(key))} className={styles.checkbox} />}
          </div>;
    })}
      {isModal && <Text type="body2" className={classnames(styles.link, {
      [styles.invisibleButton]: !starsFilter
    })} onClick={clearStarsFilter}>
          {clearFilters}
        </Text>}
    </div>;
};
RatingBars.displayName = 'RatingBars';